import React from 'react';
import { toPitched, toPlan } from '@/utils/pitch';

// Two linked length boxes: Plan (Google Earth) and Pitched (true).
// Typing Plan works out Pitched; typing Pitched keeps it and works Plan back.
export function PlanPitchedFields({ kind, pitchDeg, plan, pitched, source, onChange, testId, autoFocusPitched = false, compact = false }) {
  const num = (v) => (v === '' || v === null || v === undefined ? '' : v);
  const setPlan = (raw) => {
    const v = raw === '' ? 0 : parseFloat(raw) || 0;
    onChange({ plan: v, pitched: v ? (toPitched(v, kind, pitchDeg) ?? pitched ?? 0) : 0, source: 'plan' });
  };
  const setPitched = (raw) => {
    const v = raw === '' ? 0 : parseFloat(raw) || 0;
    onChange({ pitched: v, plan: toPlan(v, kind, pitchDeg) ?? 0, source: 'true' });
  };
  const box = `w-full ${compact ? 'px-2 py-1.5' : 'px-3 py-2'} border rounded text-sm font-mono-num`;
  const tag = (s) => (source && source !== s ? <span className="ml-1 normal-case font-normal text-slate-400">(worked out)</span> : null);
  return (
    <div data-testid={testId}>
      <div className="grid grid-cols-2 gap-2">
        <label className="block">
          <span className="block text-[10px] font-bold uppercase tracking-wider text-slate-500 mb-1">Plan (m){tag('plan')}</span>
          <input type="number" min={0} step={0.1} data-testid={`${testId}-plan`}
                 value={num(plan) === 0 ? '' : num(plan)} disabled={!pitchDeg}
                 onFocus={(e) => e.target.select()} onChange={(e) => setPlan(e.target.value)}
                 placeholder={pitchDeg ? 'Google Earth' : 'needs angle'}
                 className={`${box} border-slate-200 disabled:bg-slate-50`} />
        </label>
        <label className="block">
          <span className="block text-[10px] font-bold uppercase tracking-wider text-slate-500 mb-1">Pitched (m){tag('true')}</span>
          <input type="number" min={0} step={0.1} data-testid={`${testId}-pitched`} autoFocus={autoFocusPitched}
                 value={num(pitched) === 0 || num(pitched) === '0' ? '' : num(pitched)}
                 onFocus={(e) => e.target.select()} onChange={(e) => setPitched(e.target.value)}
                 placeholder="true length" className={`${box} border-emerald-300`} />
        </label>
      </div>
      <div className="mt-1 text-[10px] text-slate-500" data-testid={`${testId}-angle`}>
        {pitchDeg ? `Roof angle ${pitchDeg}° (Roof Details)` : 'Set Roof Angle or Pitch in Roof Details to use plan lengths'}
      </div>
    </div>
  );
}
